export default {
  topMenu: {
    logoUrl: 'static/img/logo-v2.png',
    sideNameFirstPart: 'FOGLALJ',
    sideNameSecondPart: 'PÁLYÁT',
    profileMenu: 'Profil',
    logOutMenu: 'Kijelentkezés',
    logInMenu: 'Bejelentkezés',
    signUpMenu: 'Regisztráció',
    payNegativeBalanceMenu: 'Egyenleg kiegyenlítése',
    partnerFinderBtn: 'Nincs partnerem',
    backToDigitalBtn: 'Visszalépés',
  },
  howItWork: {
    firstStepIconUrl: 'static/img/reg-icon.png',
    firstStepText: 'Regisztrálj!',
    secondStepIconUrl: 'static/img/search-icon.png',
    secondStepText: 'Keress pályát!',
    thirdStepIconUrl: 'static/img/reservation-icon.png',
    thirdStepText: 'Foglaljp időpontot!',
    forthStepIconUrl: 'static/img/play-icon.png',
    forthStepText: 'Jó játékot!',
  },
  footer: {
    callUsFirstPart: 'KERESS',
    callUsSecondPart: 'MINKET!',
    logoUrl: 'static/img/logo-v2.png',
    logoAlt: 'foglalj pályát logo',
    footerSiteNameFirstPart: 'FOGLALJ',
    footerSiteNameSecondPart: 'PÁLYÁT',
    privacyPolicy: 'Adatkezelési tájékoztató',
    team: 'Csapatunk',
    userManual: 'Használati információk',
    contactPhone: '+36 30 134 9280',
    contactMail: 'KAPCSOLAT@FOGLALJPALYAT.HU',
    contactCompanyName: 'COIMBRA ITS KFT.',
    contactAddress: '1037 BUDAPEST HUNOR UTCA 62 A/2',
  },
  mapAutoComplete: {
    placeholder: 'Hely megadása',
  },
  scheduleLegend: {
    free: 'Szabad',
    club: 'Klub',
    clubReservationImgUrl: 'static/img/club-reservation-icon.svg',
    clubReservationImgAlt: 'Klub foglalás',
    ownReservation: 'Saját foglalás',
    ownReservationImgUrl: 'static/img/own-reservation-icon.svg',
    ownReservationImgAlt: 'Saját foglalás',
    ownTrainerReservation: 'Saját edzői f.',
    ownTrainerReservationImgUrl: 'static/img/own-reservation-icon.svg',
    ownTrainerReservationImgAlt: 'Saját edzői foglalás',
    reserved: 'Foglalt',
    reservedImgUrl: 'static/img/reserved-reservation-icon.svg',
    reservedImgAlt: 'Foglalt',
    closed: 'Zárva',
    own_w_partner: 'Saját foglalás partnerrel',
    reserved_w_partner: 'Partner lefoglalta a pályát',
    own_available: 'Partnert keresel',
    partner_available: 'Valaki partnert keres',
    partner_incomings: 'Jelentkeztek a partner keresésedre',
    partner_outgoings: 'Jelentkeztél egy partner keresésre',
    partner_accepted_wo_reserve: 'Megbeszélt játék és nincs foglalt pálya!',
  },
  scheduleTableContainer: {
    dateText: 'Dátum',
    subjectTypeText: 'Pálya típus',
    reservationRulesText: 'Foglalási rend',
    resignRulesText: 'Lemondási rend',
    noTableHeaderMain: 'Sajnos erre a napra nem tudsz foglalni.',
    noTableHeaderSub: 'Módosítsd a keresési feltételeket, használd a részetes keresőt!',
  },
  aszfModal: {
    header: 'Adatkezelési tájékoztató',
    subHeader: 'Bevezetés',
    p1: 'A https://foglaljpalyat.hu weboldalt (foglaló rendszert) COIMBRA ITS Kft. (1037 Budapest, Hunor utca 62. A. lház. fszt. 2., adószám: 13872702-2-41, cégvezető: Siska Zoltán, tel.: +36 1 4067758)  (a továbbiakban: Szolgáltató, adatkezelő) alá veti magát a következő tájékoztatónak.',
    p2: 'A természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről (általános adatvédelmi rendelet) AZ EURÓPAI PARLAMENT ÉS A TANÁCS (EU) 2016/679 RENDELETE (2016. április 27.) szerint az alábbi tájékoztatást adjuk.',
    p3: 'Jelen adatkezelési tájékoztató az alábbi oldalak adatkezelését szabályozza: https://foglaljpalyat.hu',
    p4: 'Az adatkezelési tájékoztató elérhető az alábbi oldalról: https://foglaljpalyat.hu',
    p5: 'A tájékoztató módosításai a fenti címen történő közzététellel lépnek hatályba. ',
    subHeader2: 'Az adatkezelő és elérhetőségei:',
    p_2_1: 'Név: COIMBRA ITS Kft.',
    p_2_2: 'Székhely: 1037 Budapest, Hunor utca 62. A. lház. fszt. 2.',
    p_2_3: 'E-mail: info@coimbraits.hu',
    p_2_4: 'Telefon: +36 1 4067758',
    subHeader3: 'Fogalom meghatározások',
    p_3_1: '„személyes adat”: azonosított vagy azonosítható természetes személyre („érintett”) vonatkozó bármely információ; azonosítható az a természetes személy, aki közvetlen vagy közvetett módon, különösen valamely azonosító, például név, szám, helymeghatározó adat, online azonosító vagy a természetes személy testi, fiziológiai, genetikai, szellemi, gazdasági, kulturális vagy szociális azonosságára vonatkozó egy vagy több tényező alapján azonosítható;',
    p_3_2: '„adatkezelés”: a személyes adatokon vagy adatállományokon automatizált vagy nem automatizált módon végzett bármely művelet vagy műveletek összessége, így a gyűjtés, rögzítés, rendszerezés, tagolás, tárolás, átalakítás vagy megváltoztatás, lekérdezés, betekintés, felhasználás, közlés továbbítás, terjesztés vagy egyéb módon történő hozzáférhetővé tétel útján, összehangolás vagy összekapcsolás, korlátozás, törlés, illetve megsemmisítés;',
    p_3_3: '„adatkezelő”: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely a személyes adatok kezelésének céljait és eszközeit önállóan vagy másokkal együtt meghatározza; ha az adatkezelés céljait és eszközeit az uniós vagy a tagállami jog határozza meg, az adatkezelőt vagy az adatkezelő kijelölésére vonatkozó különös szempontokat az uniós vagy a tagállami jog is meghatározhatja;',
    p_3_4: '„adatfeldolgozó”: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, amely az adatkezelő nevében személyes adatokat kezel;',
    p_3_5: '„címzett”: az a természetes vagy jogi személy, közhatalmi szerv, ügynökség vagy bármely egyéb szerv, akivel vagy amellyel a személyes adatot közlik, függetlenül attól, hogy harmadik fél-e. Azon közhatalmi szervek, amelyek egy egyedi vizsgálat keretében az uniós vagy a tagállami joggal összhangban férhetnek hozzá személyes adatokhoz, nem minősülnek címzettnek; az említett adatok e közhatalmi szervek általi kezelése meg kell, hogy feleljen az adatkezelés céljainak megfelelően az alkalmazandó adatvédelmi szabályoknak;',
    p_3_6: '„az érintett hozzájárulása”: az érintett akaratának önkéntes, konkrét és megfelelő tájékoztatáson alapuló és egyértelmű kinyilvánítása, amellyel az érintett nyilatkozat vagy a megerősítést félreérthetetlenül kifejező cselekedet útján jelzi, hogy beleegyezését adja az őt érintő személyes adatok kezeléséhez;',
    p_3_7: '„adatvédelmi incidens”: a biztonság olyan sérülése, amely a továbbított, tárolt vagy más módon kezelt személyes adatok véletlen vagy jogellenes megsemmisítését, elvesztését, megváltoztatását, jogosulatlan közlését vagy az azokhoz való jogosulatlan hozzáférést eredményezi.',
    subHeader4: 'A személyes adatok kezelésére vonatkozó elvek',
    subHeader5: 'A személyes adatok:',
    p_4_1: 'kezelését jogszerűen és tisztességesen, valamint az érintett számára átlátható módon kell végezni („jogszerűség, tisztességes eljárás és átláthatóság”);',
    p_4_2: 'gyűjtése csak meghatározott, egyértelmű és jogszerű célból történjen, és azokat ne kezeljék ezekkel a célokkal össze nem egyeztethető módon; a 89. cikk (1) bekezdésének megfelelően nem minősül az eredeti céllal össze nem egyeztethetőnek a közérdekű archiválás céljából, tudományos és történelmi kutatási célból vagy statisztikai célból történő további adatkezelés („célhoz kötöttség”);',
    p_4_3: 'az adatkezelés céljai szempontjából megfelelőek és relevánsak kell, hogy legyenek, és a szükségesre kell korlátozódniuk („adattakarékosság”);',
    p_4_4: 'pontosnak és szükség esetén naprakésznek kell lenniük; minden észszerű intézkedést meg kell tenni annak érdekében, hogy az adatkezelés céljai szempontjából pontatlan személyes adatokat haladéktalanul töröljék vagy helyesbítsék („pontosság”);',
    p_4_5: 'tárolásának olyan formában kell történnie, amely az érintettek azonosítását csak a személyes adatok kezelése céljainak eléréséhez szükséges ideig teszi lehetővé; a személyes adatok ennél hosszabb ideig történő tárolására csak akkor kerülhet sor, amennyiben a személyes adatok kezelésére a 89. cikk (1) bekezdésének megfelelően közérdekű archiválás céljából, tudományos és történelmi kutatási célból vagy statisztikai célból kerül majd sor, az e rendeletben az érintettek jogainak és szabadságainak védelme érdekében előírt megfelelő technikai és szervezési intézkedések végrehajtására is figyelemmel („korlátozott tárolhatóság”);',
    p_4_6: 'kezelését oly módon kell végezni, hogy megfelelő technikai vagy szervezési intézkedések alkalmazásával biztosítva legyen a személyes adatok megfelelő biztonsága, az adatok jogosulatlan vagy jogellenes kezelésével, véletlen elvesztésével, megsemmisítésével vagy károsodásával szembeni védelmet is ideértve („integritás és bizalmas jelleg”).',
    p_5_1: 'Az adatkezelő felelős a fentiek megfelelésért, továbbá képesnek kell lennie e megfelelés igazolására („elszámoltathatóság”).',
    subHeader6: 'Adatkezelések',
    subHeader7: 'Üzenetküldés, kapcsolatfelvétel',
    p_6_1: 'Az adatgyűjtés ténye, a kezelt adatok köre és az adatkezelés célja:',
    p_6_2: 'Személyes adat',
    p_6_3: 'Az adatkezelés célja',
    p_6_4: 'Név, e-mail cím.',
    p_6_5: 'Kapcsolattartás, azonosítás.Cell',
    p_6_6: 'Az üzenetküldés időpontja',
    p_6_7: 'Technikai művelet végrehajtása.',
    p_6_8: 'Az üzenetküldés kori IP cím',
    p_6_9: 'Technikai művelet végrehajtása.',
    p_6_10: 'Az érintettek köre: A weboldalon üzenetet küldő/érdeklődő valamennyi érintett.',
    p_6_11: 'Az adatkezelés időtartama, az adatok törlésének határideje: Az adatkezelés az ügy elintézéséig tart.',
    p_6_12: 'Az adatok megismerésére jogosult lehetséges adatkezelők személye: A személyes adatokat az adatkezelő kezelheti, a fenti alapelvek tiszteletben tartásával.',
    subHeader8: 'Az érintettek adatkezeléssel kapcsolatos jogainak ismertetése: ',
    p_7_1: 'Az érintett kérelmezheti az adatkezelőtől a rá vonatkozó személyes adatokhoz való hozzáférést, azok helyesbítését, törlését vagy kezelésének korlátozását, és',
    p_7_2: 'tiltakozhat az ilyen személyes adatok kezelése ellen, valamint ',
    p_7_3: 'az érintettnek joga van az adathordozhatósághoz, továbbá a hozzájárulás bármely időpontban történő visszavonásához.',
    p_7_4: 'A személyes adatok törlését, vagy módosítását az alábbi módokon tudja érintett kezdeményezni:',
    p_7_5: 'postai úton a 1037 Budapest, Hunor utca 62. A. lház. fszt. 2.,',
    p_7_6: 'e-mail útján a info@coimbraits.hu e-mail címen, ',
    p_7_7: 'telefonon a +36 1 4067758 számon.',
    p_7_8: 'Az adatkezelés jogalapja: az érintett hozzájárulása, 6. cikk (1) bekezdés a) pont, az Infotv. 5. § (1) bekezdése',
    p_7_9: 'Tájékoztatjuk, hogy',
    p_7_10: 'az adatkezelés az Ön hozzájárulásán',
    p_7_11: 'alapul.',
    p_7_12: 'köteles',
    p_7_13: 'a személyes adatokat megadni, hogy tudjuk az üzenetre válaszolni.',
    p_7_14: 'az adatszolgáltatás elmaradása azzal a',
    p_7_15: 'következményekkel',
    p_7_16: 'jár, hogy nem tudjuk a kérését teljesíteni.',
    list1: `<h5>Regisztráció/foglalás</h5>
      <ol>
        <li>
          Az adatgyűjtés ténye, a kezelt adatok köre és az adatkezelés célja:
          <table class="ui celled table">
            <thead>
            <tr>
              <th>Személyes adat</th>
              <th>Az adatkezelés célja</th>
            </tr></thead>
            <tbody>
            <tr>
              <td>Jelszó</td>
              <td>A felhasználói fiókba történő biztonságos belépést szolgálja.</td>
            </tr>
            <tr>
              <td>Vezeték-és keresztnév</td>
              <td>A kapcsolatfelvételhez és azonosításhoz szükséges.</td>
            </tr>
            <tr>
              <td>E-mail cím</td>
              <td>Kapcsolattartás.</td>
            </tr>
            <tr>
              <td>Telefonszám</td>
              <td>Kapcsolattartás, adatok egyeztetése, foglalássokkal kapcsolatos ügyintézés.</td>
            </tr>
            <tr>
              <td>A foglalással kapcsolatos további esetleges személyes adatok</td>
              <td>A foglalás biztosítása.</td>
            </tr>
            <tr>
              <td>A regisztráció/foglalás időpontja</td>
              <td>Technikai művelet végrehajtása.</td>
            </tr>
            <tr>
              <td>A regisztráció kori/foglalás kori IP cím</td>
              <td>Technikai művelet végrehajtása.</td>
            </tr>
            </tbody>
          </table>
          <p>A Weboldalon történő regisztráció és a Weboldal használata (foglalás) során: Az adatkezelés célja a Weboldalon elérhető szolgáltatások nyújtásának biztosítása, a weboldal üzemeltetéséhez kapcsolódó adatbázis kezelése, a foglalás teljesítése céljából az adatok továbbítása a Felhasználó által kiválasztott, az Adatkezelővel szerződéses viszonyban álló Partner cég  részére, valamint kapcsolattartás. </p>
          <p>Az e-mail cím nem szükséges, hogy személyes adatot tartalmazzon.</p>
        </li>
        <li>Az érintettek köre: A weboldalon regisztrált/foglaló valamennyi érintett.</li>
        <li>Az adatkezelés időtartama, az adatok törlésének határideje: A regisztráció törléséig/az érintett törlési kéréséig tart az adatkezelés.</li>
        <li>Az adatok megismerésére jogosult lehetséges adatkezelők személye: A személyes adatokat az adatkezelő munkatársai kezelhetik, a fenti alapelvek tiszteletben tartásával.</li>
        <li>
          Az érintettek adatkezeléssel kapcsolatos jogainak ismertetése:
          <ul>
            <li>Az érintett kérelmezheti az adatkezelőtől a rá vonatkozó személyes adatokhoz való hozzáférést, azok helyesbítését, törlését vagy kezelésének korlátozását, és</li>
            <li>tiltakozhat az ilyen személyes adatok kezelése ellen, valamint </li>
            <li>az érintettnek joga van az adathordozhatósághoz, továbbá a hozzájárulás bármely időpontban történő visszavonásához.</li>
          </ul>
        </li>
        <li>
          A személyes adatok törlését, vagy módosítását az alábbi módokon tudja érintett kezdeményezni:
          <ul>
            <li>postai úton a 1037 Budapest, Hunor utca 62. A. lház. fszt. 2.,</li>
            <li>e-mail útján a info@coimbraits.hu e-mail címen, </li>
            <li>telefonon a +36 1 4067758 számon.</li>
          </ul>
        </li>
        <li>
          Az adatkezelés jogalapja: az érintett hozzájárulása, 6. cikk (1) bekezdés a) pont, az Infotv. 5. § (1) bekezdése, illetve az elektronikus kereskedelemi szolgáltatások, valamint az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről szóló 2001. évi CVIII. törvény (a továbbiakban: Elker tv.) 13/A. § (3) bekezdése:
          <em>A szolgáltató a szolgáltatás nyújtása céljából kezelheti azon személyes adatokat, amelyek a szolgáltatás nyújtásához technikailag elengedhetetlenül szükségesek. A szolgáltatónak az egyéb feltételek azonossága esetén úgy kell megválasztania és minden esetben oly módon kell üzemeltetnie az információs társadalommal összefüggő szolgáltatás nyújtása során alkalmazott eszközöket, hogy személyes adatok kezelésére csak akkor kerüljön sor, ha ez a szolgáltatás nyújtásához és az e törvényben meghatározott egyéb célok teljesüléséhez feltétlenül szükséges, azonban ebben az esetben is csak a szükséges mértékben és ideig.</em>
        </li>
        <li>
          Tájékoztatjuk, hogy
          <ul>
            <li><strong>az adatkezelés az Ön hozzájárulásán</strong> alapul.</li>
            <li><strong>köteles</strong> a személyes adatokat megadni, hogy foglalni tudjon a weboldalon keresztül</li>
            <li>az adatszolgáltatás elmaradása azzal a <strong>következményekkel</strong> jár, hogy nem tud foglalni a weboldalon</li>
          </ul>
        </li>
      </ol>`,
    list2: `<h5>Adattovábbítás</h5>
      <p>A Weboldalon elérhető szolgáltatás teljesítése érdekében Adatkezelő a Felhasználó Regisztráció során megadott adatai közül a foglalás teljesítéséhez szükséges adatokat – Felhasználó neve, e-mail címe, telefonszáma, foglalás adatai – átadja annak a Partnernek, amelytől a Felhasználó a Weboldalon elérhető szolgáltatást (foglalás) meg kívánja rendelni. </p>
      <p>Adatkezelő kijelenti, hogy az adatok Partner részére történő átadását követően ezen adatok Partner általi kezelésének jogszerűsége tekintetében felelősséget nem vállal. A Felhasználó a Partner adatkezelésével kapcsolatban felvilágosítást a Partner honlapján, illetve egyéb elérhetőségein kaphat.</p>
      <h5>Adattovábbítás - "Club" partnerkereső szolgáltatás</h5>
      <p>Amennyiben a Felhasználó a "Club" partnerkereső szolgáltatásra jelentkezik és abban egy másik felhasználóval közös játékot egyeztet (az egyeztetés kölcsönös, aktív visszaigazolással történik), az Adatkezelő mindkét Felhasználó személyes adatait (név, telefonszám, email cím) kapcsolatfelvétel céljából továbbítja a játékostársnak.</p>
      <h5>Technikai adatok</h5>
      <p>Az Érintett bejelentkező számítógépének azon adatai, melyek a szolgáltatás igénybe vétele során generálódnak és melyeket az Adatkezelő rendszere a technikai folyamatok automatikus eredményeként rögzít. Ezek különösen a látogatás dátuma és időpontja, az Érintett számítógépének IP címe, böngészőjének típusa, a megtekintett és az előzőleg látogatott weboldal címe.</p>
      <p>Az automatikusan rögzítésre kerülő adatokat a rendszer az Érintett külön nyilatkozata vagy cselekménye nélkül a belépéskor, illetve kilépéskor automatikusan naplózza. </p>
      <p>A Honlap html kódja az Adatkezelőtől független, külső szerverről érkező és külső szerverre mutató hivatkozásokat tartalmazhat. E hivatkozások Adatkezelői az ő szerverükre történő közvetlen kapcsolódás miatt felhasználói adatokat képesek gyűjteni.</p>
      <h5>Cookie-k (sütik) kezelése</h5>
      <p>Az Adatkezelő, illetve a megjelölt külső Adatfeldolgozók a testre szabott kiszolgálás érdekében az Érintett számítógépén kis adatcsomagot, ún. sütit (cookie) helyeznek el és olvasnak vissza. Ha a böngésző visszaküld egy korábban elmentett sütit, a sütit kezelő Adatfeldolgozónak lehetősége van összekapcsolni az Érintett aktuális látogatásai során elmentett adatait a korábbiakkal, de kizárólag a saját tartalma tekintetében.</p>
      <p>Adatkezelő a következő cookie-t használja:</p>
      <p>Átmeneti (session) cookie: a session cookie-k az Érintett látogatása után automatikusan törlődnek. Ezek a cookie-k arra szolgálnak, hogy az Adatkezelő Honlapja hatékonyabban és biztonságosabban tudjon működni, tehát elengedhetetlenek ahhoz, hogy a Honlap egyes funkciói vagy egyes alkalmazások megfelelően tudjanak működni.</p>
      <p>Állandó (persistent) cookie: állandó cookie-t is használ az Adatkezelő a jobb felhasználói élmény érdekében (pl. optimalizált navigáció nyújtása). Ezek a cookie-k hosszabb ideig kerülnek tárolásra a böngésző cookie file-jában. Ennek időtartama attól függ, hogy az Érintett az internetes böngészőjében milyen beállítást alkalmaz. </p>
      <p>A legtöbb böngésző menüsorában található „Segítség” funkció, tájékoztatást nyújt arra vonatkozóan, hogy az Érintett saját böngészőjében</p>
      <ul>
        <li>hogyan tudja letiltani a cookie-kat, </li>
        <li>hogyan fogadhat el új cookie-kat, </li>
        <li>hogyan adhat utasítást böngészőjének arra, hogy új cookie-t állítson be, vagy </li>
        <li>hogyan kapcsoljon ki egyéb cookie-kat.</li>
      </ul>
      <ol>
        <li>Az adatkezelés ténye, a kezelt adatok köre: Egyedi azonosítószám, dátumok, időpontok</li>
        <li>Az érintettek köre: A weboldalt látogató valamennyi érintett.</li>
        <li>Az adatkezelés célja: A felhasználók azonosítása és a felhasználói élmény javítása.</li>
        <li>
          Az adatkezelés időtartama, az adatok törlésének határideje:
          <table class="ui celled table">
            <thead>
            <tr>
              <th>Süti típusa</th>
              <th>Adatkezelés jogalapja</th>
              <th>Adatkezelés időtartama</th>
              <th>Kezelt adatkör, adatkezelés célja</th>
            </tr></thead>
            <tbody>
            <tr>
              <td>Munkamenet sütik (session)</td>
              <td>Az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalmi szolgáltatások egyes kérdéseiről szóló 2001. CVIII. törvény (Elkertv.) 13/A. § (3) bekezdése</td>
              <td>A vonatkozó látogatói munkamenet lezárásáig tartó időszak</td>
              <td>név, email cím, azonosító, webshop kosár azonosító</td>
            </tr>
            <tr>
              <td>Állandó süti (persistent)</td>
              <td>Az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalmi szolgáltatások egyes kérdéseiről szóló 2001. CVIII. törvény (Elkertv.) 13/A. § (3) bekezdése</td>
              <td>A süti elfogadásától számított öt évig.</td>
              <td>rendszerüzenet elfogadása</td>
            </tr>
            <tr>
              <td>Google Analytics által elhelyezett sütik</td>
              <td>Az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalmi szolgáltatások egyes kérdéseiről szóló 2001. CVIII. törvény (Elkertv.) 13/A. § (3) bekezdése</td>
              <td>A weblap első látogatásától számított két évig.</td>
              <td>látogatók azonosítása, megkülönböztetése, egyéni változó adatok tárolása, forgalmi forrás vagy a kampány tárolása </td>
            </tr>
            </tbody>
          </table>
        </li>
        <li>Az adatok megismerésére jogosult lehetséges adatkezelők személye: A cookie-k használatával nem kezel személyes adatokat az adatkezelő.</li>
        <li>Az érintettek adatkezeléssel kapcsolatos jogainak ismertetése: Az érintettnek lehetőségük van a cookie-kat törölni a böngészők Eszközök/Beállítások menüjében általában az Adatvédelem menüpont beállításai alatt.</li>
        <li>Az adatkezelés jogalapja: Az érintettől hozzájárulás nem szükséges, amennyiben a cookie-k használatának kizárólagos célja az elektronikus hírközlő hálózaton keresztül történő közléstovábbítás vagy arra az előfizető vagy felhasználó által kifejezetten kért, az információs társadalommal összefüggő szolgáltatás nyújtásához a szolgáltatónak feltétlenül szüksége van.</li>
      </ol>`,
    list3: `<p>A Google által használt cookie-król (sütikről) további információ megtekinthető a következő linken: http://www.google.com/policies/technologies/ads/</p>
      <p>A Google adatvédelmi nyilatkozata megtekinthető az alábbi linken: <a href="http://www.google.com/intl/hu/policies/privacy/">http://www.google.com/intl/hu/policies/privacy/</a>.</p>
      <h5>Közösségi oldalak</h5>
      <ol>
        <li>Az adatgyűjtés ténye, a kezelt adatok köre: Facebook/Google+/Twitter/Pinterest/Youtube/Instagram stb. közösségi oldalakon regisztrált neve, illetve a felhasználó nyilvános profilképe.</li>
        <li>Az érintettek köre: Valamennyi érintett, aki regisztrált a Facebook/Google+/Twitter/Pinterest/Youtube/Instagram stb. közösségi oldalakon, és „lájkolta” a weboldalt.</li>
        <li>Az adatgyűjtés célja: A közösségi oldalakon, a weboldal egyes tartalmi elemeinek, termékeinek, akcióinak vagy magának a weboldalnak a megosztása, illetve „lájkolása”, népszerűsítése.</li>
        <li>Az adatkezelés időtartama, az adatok törlésének határideje, az adatok megismerésére jogosult lehetséges adatkezelők személye és az érintettek adatkezeléssel kapcsolatos jogainak ismertetése: Az adatok forrásáról, azok kezeléséről, illetve az átadás módjáról, és jogalapjáról az adott közösségi oldalon tájékozódhat az érintett. Az adatkezelés a közösségi oldalakon valósul meg, így az adatkezelés időtartamára, módjára, illetve az adatok törlési és módosítási lehetőségeire az adott közösségi oldal szabályozása vonatkozik.</li>
        <li>Az adatkezelés jogalapja: az érintett önkéntes hozzájárulása személyes adatai kezeléséhez a közösségi oldalakon.</li>
      </ol>
      <h5>Ügyfélkapcsolatok és egyéb adatkezelések</h5>
      <ol>
        <li>Amennyiben az adatkezelő szolgáltatásaink igénybevétele során kérdés merülne fel, esetleg problémája lenne az érintettnek, a honlapon megadott módokon (telefon, e-mail, közösségi oldalak stb.) kapcsolatba léphet az adatkezelővel.</li>
        <li>Adatkezelő a beérkezett e-maileket, üzeneteket, telefonon, Facebook-on stb. megadott adatokat az érdeklődő nevével és e-mail címével, valamint más, önként megadott személyes adatával együtt, az adatközléstől számított legfeljebb 2 év elteltével törli.</li>
        <li>E tájékoztatóban fel nem sorolt adatkezelésekről az adat felvételekor adunk tájékoztatást.</li>
        <li>Kivételes hatósági megkeresésre, illetőleg jogszabály felhatalmazása alapján más szervek megkeresése esetén a Szolgáltató köteles tájékoztatás adására, adatok közlésére, átadására, illetőleg iratok rendelkezésre bocsátására.</li>
        <li>A Szolgáltató ezen esetekben a megkereső részére – amennyiben az a pontos célt és az adatok körét megjelölte – személyes adatot csak annyit és olyan mértékben ad ki, amely a megkeresés céljának megvalósításához elengedhetetlenül szükséges.</li>
      </ol>
      <h3>Az érintettek jogai</h3>
      <ol>
        <li>
          <h5>A hozzáférés joga</h5>
          <p>Ön jogosult arra, hogy az adatkezelőtől visszajelzést kapjon arra vonatkozóan, hogy személyes adatainak kezelése folyamatban van-e, és ha ilyen adatkezelés folyamatban van, jogosult arra, hogy a személyes adatokhoz és a rendeletben felsorolt információkhoz hozzáférést kapjon.</p>
        </li>
        <li>
          <h5>A helyesbítéshez való jog</h5>
          <p>Ön jogosult arra, hogy kérésére az adatkezelő indokolatlan késedelem nélkül helyesbítse a rá vonatkozó pontatlan személyes adatokat. Figyelembe véve az adatkezelés célját, Ön jogosult arra, hogy kérje a hiányos személyes adatok – egyebek mellett kiegészítő nyilatkozat útján történő – kiegészítését.</p>
        </li>
        <li>
          <h5>A törléshez való jog</h5>
          <p>Ön jogosult arra, hogy kérésére az adatkezelő indokolatlan késedelem nélkül törölje a rá vonatkozó személyes adatokat, az adatkezelő pedig köteles arra, hogy Önre vonatkozó személyes adatokat indokolatlan késedelem nélkül törölje meghatározott feltételek esetén.</p>
        </li>
        <li>
          <h5>Az elfeledtetéshez való jog</h5>
          <p>Ha az adatkezelő nyilvánosságra hozta a személyes adatot, és azt törölni köteles, az elérhető technológia és a megvalósítás költségeinek figyelembevételével megteszi az ésszerűen elvárható lépéseket – ideértve technikai intézkedéseket – annak érdekében, hogy tájékoztassa az adatokat kezelő adatkezelőket, hogy Ön kérelmezte a szóban forgó személyes adatokra mutató linkek vagy e személyes adatok másolatának, illetve másodpéldányának törlését.</p>
        </li>
        <li>
          <h5>Az adatkezelés korlátozásához való jog</h5>
          <p>Ön jogosult arra, hogy kérésére az adatkezelő korlátozza az adatkezelést, ha az alábbi feltételek valamelyike teljesül:</p>
          <ul>
            <li>Ön vitatja a személyes adatok pontosságát, ez esetben a korlátozás arra az időtartamra vonatkozik, amely lehetővé teszi, hogy az adatkezelő ellenőrizze a személyes adatok pontosságát; </li>
            <li>az adatkezelés jogellenes, és Ön ellenzi az adatok törlését, és ehelyett kéri azok felhasználásának korlátozását; </li>
            <li>az adatkezelőnek már nincs szüksége a személyes adatokra adatkezelés céljából, de Ön igényli azokat jogi igények előterjesztéséhez, érvényesítéséhez vagy védelméhez; </li>
            <li>Ön tiltakozott az adatkezelés ellen; ez esetben a korlátozás arra az időtartamra vonatkozik, amíg megállapításra nem kerül, hogy az adatkezelő jogos indokai elsőbbséget élveznek-e Ön jogos indokaival szemben.</li>
          </ul>
        </li>
        <li>
          <h5>Az adathordozhatósághoz való jog</h5>
          <p>Ön jogosult arra, hogy a rá vonatkozó, általa egy adatkezelő rendelkezésére bocsátott személyes adatokat tagolt, széles körben használt, géppel olvasható formátumban megkapja, továbbá jogosult arra, hogy ezeket az adatokat egy másik adatkezelőnek továbbítsa anélkül, hogy ezt akadályozná az az adatkezelő, amelynek a személyes adatokat a rendelkezésére bocsátotta (...)</p>
        </li>
        <li>
          <h5>A tiltakozáshoz való jog</h5>
          <p>Ön jogosult arra, hogy a saját helyzetével kapcsolatos okokból bármikor tiltakozzon személyes adatainak a (...) kezelése ellen, ideértve az említett rendelkezéseken alapuló profilalkotást is. </p>
        </li>
        <li>
          <h5>Tiltakozás közvetlen üzletszerzés estén</h5>
          <p>Ha a személyes adatok kezelése közvetlen üzletszerzés érdekében történik, Ön jogosult arra, hogy bármikor tiltakozzon a rá vonatkozó személyes adatok e célból történő kezelése ellen, ideértve a profilalkotást is, amennyiben az a közvetlen üzletszerzéshez kapcsolódik. Ha Ön tiltakozik a személyes adatok közvetlen üzletszerzés érdekében történő kezelése ellen, akkor a személyes adatok a továbbiakban e célból nem kezelhetők.</p>
        </li>
        <li>
          <h5>Automatizált döntéshozatal egyedi ügyekben, beleértve a profilalkotást</h5>
          <p>
            Ön jogosult arra, hogy ne terjedjen ki rá az olyan, kizárólag automatizált adatkezelésen – ideértve a profilalkotást is – alapuló döntés hatálya, amely rá nézve joghatással járna vagy őt hasonlóképpen jelentős mértékben érintené.
            Az előző bekezdés nem alkalmazandó abban az esetben, ha a döntés:
         </p>
          <ul>
            <li>Ön és az adatkezelő közötti szerződés megkötése vagy teljesítése érdekében szükséges;</li>
            <li>meghozatalát az adatkezelőre alkalmazandó olyan uniós vagy tagállami jog teszi lehetővé, amely Ön jogainak és szabadságainak, valamint jogos érdekeinek védelmét szolgáló megfelelő intézkedéseket is megállapít; vagy</li>
            <li>Ön kifejezett hozzájárulásán alapul.</li>
          </ul>
        </li>
      </ol>
      <h3>Intézkedési határidő</h3>
      <p>Az adatkezelő indokolatlan késedelem nélkül, de mindenféleképpen a kérelem beérkezésétől számított <strong>1 hónapon belül</strong> tájékoztatja Önt a fenti kérelmek nyomán hozott intézkedésekről. </p>
      <p>Szükség esetén ez <strong>2 hónappal meghosszabbítható</strong>. A határidő meghosszabbításáról az adatkezelő a késedelem okainak megjelölésével a kérelem kézhezvételétől számított <strong>1 hónapon belül</strong> tájékoztatja Önt. </p>
      <p>Ha az adatkezelő nem tesz intézkedéseket Ön kérelme nyomán, <strong>késedelem nélkül, de legkésőbb a kérelem beérkezésétől számított egy hónapon belül tájékoztatja Önt az intézkedés elmaradásának okairól</strong>, valamint arról, hogy Ön panaszt nyújthat be valamely felügyeleti hatóságnál, és élhet bírósági jogorvoslati jogával.</p>
      <h3>Az adatkezelés biztonsága</h3>
      <p>Az adatkezelő és az adatfeldolgozó a tudomány és technológia állása és a megvalósítás költségei, továbbá az adatkezelés jellege, hatóköre, körülményei és céljai, valamint a természetes személyek jogaira és szabadságaira jelentett, változó valószínűségű és súlyosságú kockázat figyelembevételével megfelelő technikai és szervezési intézkedéseket hajt végre annak érdekében, hogy a kockázat mértékének megfelelő szintű adatbiztonságot garantálja, ideértve, többek között, adott esetben:</p>
      <ol type="a">
        <li>a személyes adatok álnevesítését és titkosítását;</li>
        <li>a személyes adatok kezelésére használt rendszerek és szolgáltatások folyamatos bizalmas jellegének biztosítását, integritását, rendelkezésre állását és ellenálló képességét;</li>
        <li>fizikai vagy műszaki incidens esetén az arra való képességet, hogy a személyes adatokhoz való hozzáférést és az adatok rendelkezésre állását kellő időben vissza lehet állítani;</li>
        <li>az adatkezelés biztonságának garantálására hozott technikai és szervezési intézkedések hatékonyságának rendszeres tesztelésére, felmérésére és értékelésére szolgáló eljárást.</li>
      </ol>
      <h3>Az érintett tájékoztatása az adatvédelmi incidensről</h3>
      <p>Ha az adatvédelmi incidens valószínűsíthetően magas kockázattal jár a természetes személyek jogaira és szabadságaira nézve, az adatkezelő indokolatlan késedelem nélkül tájékoztatja az érintettet az adatvédelmi incidensről.</p>
      <p>Az érintett részére adott tájékoztatásban világosan és közérthetően ismertetni kell az adatvédelmi incidens jellegét, és közölni kell az adatvédelmi tisztviselő vagy a további tájékoztatást nyújtó egyéb kapcsolattartó nevét és elérhetőségeit; ismertetni kell az adatvédelmi incidensből eredő, valószínűsíthető következményeket; ismertetni kell az adatkezelő által az adatvédelmi incidens orvoslására tett vagy tervezett intézkedéseket, beleértve adott esetben az adatvédelmi incidensből eredő esetleges hátrányos következmények enyhítését célzó intézkedéseket.</p>
      <p>Az érintettet nem kell tájékoztatni, ha a következő feltételek bármelyike teljesül:</p>
      <ul>
        <li>az adatkezelő <strong>megfelelő technikai és szervezési védelmi intézkedéseket hajtott végre</strong>, és ezeket az intézkedéseket az adatvédelmi incidens által érintett adatok tekintetében alkalmazták, különösen azokat az intézkedéseket – mint például a titkosítás alkalmazása –, amelyek a személyes adatokhoz való hozzáférésre fel nem jogosított személyek számára <strong>értelmezhetetlenné teszik az adatokat</strong>;</li>
        <li>az adatkezelő az adatvédelmi incidenst követően olyan további intézkedéseket tett, amelyek <strong>biztosítják, hogy az érintett jogaira és szabadságaira jelentett, magas kockázat a továbbiakban valószínűsíthetően nem valósul meg</strong>;</li>
        <li>a tájékoztatás <strong>aránytalan erőfeszítést tenne szükségessé</strong>. Ilyen esetekben az érintetteket nyilvánosan közzétett információk útján kell tájékoztatni, vagy olyan hasonló intézkedést kell hozni, amely biztosítja az érintettek hasonlóan hatékony tájékoztatását.</li>
      </ul>
      <p>Ha az adatkezelő még nem értesítette az érintettet az adatvédelmi incidensről, a felügyeleti hatóság, miután mérlegelte, hogy az adatvédelmi incidens valószínűsíthetően magas kockázattal jár-e, elrendelheti az érintett tájékoztatását.</p>
      <h3>Adatvédelmi incidens bejelentése a hatóságnak</h3>
      <p>Az adatvédelmi incidenst az adatkezelő indokolatlan késedelem nélkül, és ha lehetséges, legkésőbb 72 órával azután, hogy az adatvédelmi incidens a tudomására jutott, bejelenti az 55. cikk alapján illetékes felügyeleti hatóságnak, kivéve, ha az adatvédelmi incidens valószínűsíthetően nem jár kockázattal a természetes személyek jogaira és szabadságaira nézve. Ha a bejelentés nem történik meg 72 órán belül, mellékelni kell hozzá a késedelem igazolására szolgáló indokokat is.</p>
      <h3>Panasztételi lehetőség</h3>
      <p>Az adatkezelő esetleges jogsértése ellen panasszal a Nemzeti Adatvédelmi és Információszabadság Hatóságnál lehet élni: </p>
      <p>
        Nemzeti Adatvédelmi és Információszabadság Hatóság <br>
        1125 Budapest, Szilágyi Erzsébet fasor 22/C. <br>
        Levelezési cím: 1530 Budapest, Postafiók: 5. <br>
        Telefon: +36 -1-391-1400 <br>
        Fax: +36-1-391-1410 <br>
        E-mail: ugyfelszolgalat@naih.hu <br>
      </p>
      <h3>Zárszó</h3>
      <p>A tájékoztató elkészítése során figyelemmel voltunk az alábbi jogszabályokra: </p>
      <ul>
        <li>A természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről (általános adatvédelmi rendelet) AZ EURÓPAI PARLAMENT ÉS A TANÁCS (EU) 2016/679 RENDELETE (2016. április 27.)</li>
        <li>2011. évi CXII. törvény – az információs önrendelkezési jogról és az információszabadságról (a továbbiakban: Infotv.)</li>
        <li>2001. évi CVIII. törvény – az elektronikus kereskedelmi szolgáltatások, valamint az információs társadalommal összefüggő szolgáltatások egyes kérdéseiről (főképp a 13/A. §-a)</li>
        <li>2008. évi XLVII. törvény – a fogyasztókkal szembeni tisztességtelen kereskedelmi gyakorlat tilalmáról;</li>
        <li>2008. évi XLVIII. törvény – a gazdasági reklámtevékenység alapvető feltételeiről és egyes korlátairól (különösen a 6.§-a)</li>
        <li>2005. évi XC. törvény az elektronikus információszabadságról</li>
        <li>2003. évi C. törvény az elektronikus hírközlésről (kifejezetten a 155.§-a)</li>
        <li>16/2011. sz. vélemény a viselkedésalapú online reklám bevált gyakorlatára vonatkozó EASA/IAB-ajánlásról</li>
        <li>A Nemzeti Adatvédelmi és Információszabadság Hatóság ajánlása az előzetes tájékoztatás adatvédelmi követelményeiről</li>
        <li>Az Európai Parlament és a Tanács (EU) 2016/679 rendelete (2016. április 27.) a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK rendelet hatályon kívül helyezéséről</li>
      </ul>`,
  },
  changeAddressModal: {
    header: 'Számlázási cím módosítása',
    country: 'Ország',
    zip: 'Irányítószám',
    city: 'Város',
    address: 'Cím (Utca, hsz...)',
    changeAddressBtnText: 'Cím módosítása',
  },
  changeEmailModal: {
    header: 'Email-cím módosítás',
    newMainAddress: 'Új Email-cím',
    newMainPlaceholder: 'minta@mail.hu',
    changeEmailBtnText: 'Email módosítása',
  },
  changePhoneNumberModal: {
    header: 'Telefonszám módosítása',
    changePhoneNumberBtnText: 'Telefonszám módosítása',
    placeholder: 'Adja meg telefonszámát',
  },
  citySelectModal: {
    header: 'Helyszín választás',
  },
  loginModal: {
    header: 'Bejelentkezés',
    emailLabel: 'Email cím',
    emailPlaceholder: 'minta@mail.hu',
    pwdLabel: 'Jelszó',
    forgottenPwdBtnText: 'Elfelejtett jelszó',
    loginBtnText: 'Bejelentkezés',
  },
  newReservationModal: {
    header: 'Foglalás',
    subject: 'Pálya',
    date: 'Időpont',
    payable: 'Fizetendő',
    ticketPrice: 'Jegy ára',
    balance: 'Egyenleg',
    negativeBalancePay: 'Negatív egyenleg fizetése',
    annualPayable: 'Összesen fizetendő',
    payAndReserveBtnText: 'Fizet és Foglal',
    cancel: 'Mégse',
    payAndReserveBtnText2: 'Fizetés és foglalás',
    passBuyBtnTxt: 'Bérlet vásárlás',
    reserveBtnText: 'Foglalás',
    cancelModal: 'Mégse',
    reserveBtnText2: 'Foglalás',
    cancelModal2: 'Mégse',
    extraOptionsSubHeader: 'Választható opciók',
  },
  payNegativeBalanceModal: {
    header: 'Egyenleg kiegyenlítése',
    paymentAmount: 'Fizetendő',
    payBtnText: 'Fizetés',
    cancelModal: 'Mégse',
  },
  ownReservationModal: {
    header: 'Saját foglalás',
    subject: 'Pálya',
    date: 'Időpont',
    resignBtnText: 'Lemondás',
    cancelBtnText: 'Mégse',
    extraOptionsSubHeader: 'Választott opciók',
    reservationCode: 'Foglalási kód',
  },
  otherReservationModal: {
    header: 'A pálya foglalt',
    subject: 'Pálya',
    date: 'Időpont',
  },
  profileAllInOneModal: {
    header: 'Profil',
    myData: 'Adataim',
    fullName: 'Teljes név',
    password: 'Jelszó',
    pwdPlaceholder: '********',
    passwordAgain: 'Jelszó ismét',
    pwdAgainPlaceholder: '********',
    phoneNumber: 'Telefonszám',
    billingAddress: 'Számlázási cím',
    notSpecBillAddress: 'Nincs megadva',
    saveBtnText: 'Mentés',
    emailChangeBtnText: 'Email módosítás',
    changePhoneNumberBtn: 'Telefonszám módosítás',
    changeBillingAddressBtn: 'Számlázási cím módosítás',
    myReservations: 'Foglalásaim',
    resStatus: 'Állapot',
    resSubject: 'Pálya',
    resDate: 'Időpont',
    resClient: 'Partner',
    noReservation: 'Még nincs foglalás',
    myPasses: 'Bérleteim',
    passBuyBtnTxt: 'Bérlet vásárlás',
    pass: 'Bérlet',
    passOccasions: 'Maradék/Összes',
    passValidity: 'Érvényes',
    passBuyingDate: 'Vásárolva',
    passClient: 'Partner',
    noPass: 'Jelenleg nincs bérlete',
    myBalances: 'Egyenlegem',
    balanceClient: 'Partner',
    balance: 'Egyenleg',
    noBalance: 'Még nincs egyenlegem',
  },
  signUpModal: {
    header: 'Regisztráció',
    fullName: 'Teljes név',
    fullNamePlaceholder: 'Minta Ákos',
    email: 'Email cím',
    emailPlaceholder: 'minta@mail.com',
    pwd: 'Jelszó',
    pwdAgain: 'Jelszó ismét',
    privacyPolicyPartOne: 'Adatkezelési tájékoztató',
    privacyPolicyPartTwo: 'elfogadása',
    signUpBtn: 'Regisztráció',
  },
  teamModal: {
    header: 'Csapatunk',
    content: `<h1>Üdvözlünk itt a Foglaljpályát.hu-n</h1>
      <img v-if="!isMobileDevice" class="foglaljpalyat-right-logo" src="https://foglaljpalyat.hu/img/logo/foglaljpalyat.svg">
      <p>Oldalunk két legfőbb célja, hogy professzionális szolgáltatással elősegítsük a sportolni vágyó szabadidős
        sportolóknak megtalálni a közelükben fellelhető szabad pályákat bárhol is tartózkodjanak az  ország területén,
        és azt azonnal le is tudják foglalni, egyúttal szeretnénk jelentősen megkönnyíteni a pályákat üzemeltető
        kluboknak a foglalásokkal kapcsolatos adminisztrációs munkát.
        <br>
        <br>
        A Foglaljpályát.hu oldal ötlete  a számítástechnikai fejlesztésekkel is foglalkozó Coimbra Csoport „tenisz- és
        fallabdafüggő” dolgozóiban merült fel, mert megelégelték a pályák keresgélését és a telefonos pályafoglalást,
        különösen, amikor már a harmadik negyedik helyen is az derül ki, hogy nincs szabad pálya a kívánt időpontban.
        A Coimbra ITS programozói  az oldat a <span><img src="https://foglaljpalyat.hu/img/bsquash_logo.png"></span>
        Budakalász Squash Klub és az <span><img src="https://foglaljpalyat.hu/img/omszkpt_logo.png"></span>
        Omszk Park Tenisz Klub szakembereivel szorosan együttműködve fejlesztették ki, ezzel biztosítva a programozói
        és sport szakmai hátteret, illetve a végtelennek tűnő lehetőségek közül a tényleg hasznos szolgáltatások
        kiválasztását. Az oldal fejlesztése ma sem állt le, folyamatosan dolgozunk rajta, hogy egyre több kényelmi
        funkció hozzáadásával tovább növeljük a használhatóságot.
        <br>
        <br>
        Ahhoz, hogy elérjük az ideális szolgáltatási szintet, azaz a teljes országos lefedettséget, a lehető legtöbb
        tenisz és fallabda pályát üzemeltető szolgáltató csatlakozását szeretnénk elérni, ezért az összes szolgáltatót
        egyesével megkeressük.
        <br>
        <br>
        Ha tetszik az oldalunk, és szeretnéd, hogy kedvenc helyeidre akár a nap 24 órájában a mobilodról is
        tudj pályát foglalni vagy a foglalásaidat módosítani, hívd fel a klubod figyelmét a Foglaljpályát.hu oldalra.
        Soron kívüli beüzemelést ajánlunk azoknak a szolgáltatóknak, akik megkeresnek minket.
        Elérhetőségeinket az oldal alján találod.
        <br>
        <br>
        A Foglaljpályát.hu lelkes csapata</p>

      <div class="row">
        <div class="small-12 medium-6 columns team-member">
          <img  src="https://foglaljpalyat.hu/img/team/kornel.jpg">
          <div class="team-name">Jánosi <span>Kornél</span></div>
          <div>+36 30 134 9280</div>
          <div>janosi.kornel@foglaljpalyat.hu</div>
        </div>
        <div class="small-12 medium-6 columns team-member">
          <img src="https://foglaljpalyat.hu/img/team/zoli.jpg">
          <div class="team-name">Siska <span>Zoltán</span></div>
          <div>siska.zoltan@foglaljpalyat.hu</div>
        </div>
        <div class="small-12 medium-6 columns team-member">
          <img src="https://foglaljpalyat.hu/img/team/benjamin.jpg">
          <div class="team-name">Frész <span>Benjámin</span></div>
          <div>Fejlesztő</div>
        </div>
        <div class="small-12 medium-6 columns team-member">
          <img src="https://foglaljpalyat.hu/img/team/tami.jpg">
          <div class="team-name">Tamás <span>Judit</span></div>
          <div>Pénzügyek</div>
        </div>
        <div class="small-12 medium-6 columns team-member">
          <img src="https://foglaljpalyat.hu/img/team/peter.jpg">
          <div class="team-name">Imre <span>Péter</span></div>
          <div>imre.peter@foglaljpalyat.hu</div>
        </div>
      </div>`,
  },
  userInfoModal: {
    header: 'Alap használati információk',
    subHeader: 'Regisztráció',
    p_1_1: 'Név, email cím, jelszó megadásával.',
    p_1_2: 'Facebook - on keresztül',
    p_1_3: 'Google szolgáltatáson keresztül',
    img_1_1: 'static/img/wiki/registration.png',
    subHeader2: 'Bejelentkezés',
    p_2_1: 'Email-cím, jelszó párossal',
    p_2_2: 'Facebook',
    p_2_3: 'Google',
    img_2_1: 'static/img/wiki/login.png',
    subHeader3: 'Elfelejtett jelszó',
    p_3_1: 'Az email-cím megadása után kérhető egy új jelszó igénylő email, melyben egy linkre kattintva a felhasználó megadhatja az új jelszavát.',
    subHeader4: 'Keresés',
    img_4_1: 'static/img/wiki/search.png',
    subHeader5: 'Gyorskeresés',
    p_5_1: 'Lehetőség van a kereső mezőben gyorskeresni az elérhető klubok között, név, cím és pálya típus alapján.',
    subHeader6: 'Időpont keresés',
    p_6_1: 'A gyorskeresőn túl lehet szabad időpontot keresni játék és időpont megadásával, ez a funkció kilistázza azokat a pályákat amik megfelelnek a szűrési feltételeinknek és legalább 1 pályán minimum 1 szabad órájuk van a kért időpontban.',
    content: `<h5>Szűrés</h5>
      <p>Alapértelmezett esetben az Aktuális pozíciótól vett távolság alapján keresünk klubokat, de a szűrésen belül megadható egyedi cím is és beállítható a címtől való távolság.</p>
      <h5>Alaphelyzet</h5>
      <p>A szűrőket és a kereséseket alaphelyzetbe lehet állítani.</p>
      <h3>Klubok listája </h3>
      <p>Oldalanként egyszerre 8 klub alapvető adatait lehet megtekinteni:</p>
      <ul>
        <li>Név</li>
        <li>Cím</li>
        <li>Távolság</li>
        <li>Elérhető pálya fajták</li>
      </ul>`,
    img_5_1: 'static/img/wiki/club_list.png',
    content1: `<p>A pályás alapértelmezettként távolság szerint vannak növekvő sorba rendezve, de van lehetőség név szerinti ábécé sorba rendezni.</p>
      <h5>Útvonaltervezés</h5>
      <p>A távolságra vagy a mellette lévő navigáció ikonra kattintva új lapon megnyílik a Google térkép és  az útvonaltervezés.</p>
      <h5>Kiválasztás</h5>
      <p>A klub logójára vagy a nevére kattintva kiválasztható az adott klub és megtekinthető az adott hétre vonatkozó foglalások naptára.</p>
      <h5>Kedvencek</h5>
      <p>Bejelentkezés után lehetőség van egy kedvenc klub választására, ha a felhasználó a logók jobb felső sarkában lévő csillag ikonjára kattint.</p>
      <p>Miután kiválasztott egy kedvenc klubot, ismételt kattintással törölheti a  választást vagy másik klubra való kattintással módosíthatja a kedvencét.</p>
      <p>A kedvenc klub mindig elsőnek fog megjelenni a keresési/szűrési feltételeket figyelmen kívül hagyva.</p>
      <h5>Egyéb</h5>
      <p>A kijelölt klub kijelölésének megszüntetése.</p>
      <h3>Személyes információk</h3>
      <p>Minden személyes adat csak bejelentkezés után tekinthető meg.</p>
      <h5>Profil</h5>
      <p>Módosítható a következő adatok:</p>
      <ul>
        <li>Név</li>
        <li>Telefonszám</li>
        <li>Jelszó</li>
      </ul>`,
    img_6_1: 'static/img/wiki/profile.png',
    subHeader8: 'Foglalásaim',
    p_8_1: 'A felhasználó megtekintheti az aktív foglalásait a klubok között.',
    img_8_1: 'static/img/wiki/reservation.png',
    subHeader9: 'Bérleteim',
    img_9_1: 'static/img/wiki/pass.png',
    content3: `<p>A felhasználó megtekintheti az aktív bérleteit a klubok között.</p>
      <h5>Email cím módosítása</h5>
      <p>A profil menüpont alatt van rá lehetőség, az email-cím módosítása gombra kattintva kérhetünk egy új címre megerősítő email-t.</p>
      <p>A felhasználói email-cím csak akkor módosul, ha megerősíti azt az új címre kapott email-ben való linkre kattintva.</p>
      <h3>Foglalás</h3>
      <p>A felhasználónak foglalás leadására, bejelentkezés és a kívánt klub kiválasztása után van lehetősége.</p>
      <p>A dátum módosításával lehet megtekinteni a kívánt hétre való szabad, illetve foglalt alkalmakat.
        Amennyiben egy klubnál több fajta pályán van lehetőség foglalni, azt is itt tudja kiválasztani a felhasználó.</p>
      <p>Klubonként eltérő foglalási és lemondási szabályok a klub kiválasztása után tekinthetők meg.</p>`,
    img_10_1: 'static/img/wiki/schedule_table.png',
    content4: `<h5>Foglalás leadása</h5>
      <p>A kívánt pályára és időpontra való kattintás folyamán lehet foglalást rögzíteni, korlátozott darabszámban, mely klubonként egyéni.</p>
      <h5>Foglalás lemondása</h5>
      <p>A táblázatban lévő saját foglalásra való kattintással és megerősítéssel lehet foglalást lemondani.</p>`,
  },
  partnerFinderProfileModal: {
    title: 'Club profil',
    active: 'Részt veszek',
    phone_required: 'A telefonszám kitöltése a Club használatához kötelező:',
    phone_placeholder: 'telefonszám',
    self_rank: 'Játékerőm',
    self_tryhard: 'Elszántságom',
    rank_values: ['Kezdő', 'Amatőr', 'Közepes', 'Profi', 'Versenyző'],
    tryhard_values: ['Ez csak játék', 'Győzzön a jobbik', 'Kösd föl a gatyád'],
    adatkezelesi: `
      <h4>ADATVÉDELMI ÉS SZEMÉLYES ADATKEZELÉSI TÁJÉKOZTATÓ</h4>
      A szolgáltatás használatával hozzájárulok ahhoz, hogy az adatkezelési tájékoztatóban foglaltak szerint, egyeztetett játék esetén, kapcsolattartás céljából, személyes adataim (név, telefonszám, email cím) a másik játékos részére továbbításra kerüljön.
    `,
  },
  digitalReservationStartModal: {
    header: 'Add meg a foglalásod kódját',
    headerStep1: 'Foglalás adatai',
    headerStep2: 'Foglalás adatai',
    headerStepSuccess: 'Sikeres indítás',
    reservationCodePlaceholder: 'Foglalási kód',
    reservationCodeConfirmBtn: 'Megerősítés',
    reservationPaymentStartBtn: 'Fizetés Indítása (POS)',
    reservationPaymentWithPassStartBtn: 'Fizetés bérlettel',
    attendReservationBtn: 'Megerősítés',
    buyOtherItemsBtn: 'Termék vásárlása',
    attendCancelBtn: 'Mégse',
  },
  passBuyModal: {
    header: 'Add meg a foglalásod kódját',
    headerStep1: 'Foglalás adatai',
    headerStep2: 'Foglalás adatai',
    headerStepSuccess: 'Sikeres indítás',
    reservationCodePlaceholder: 'Foglalási kód',
    reservationCodeConfirmBtn: 'Megerősítés',
    reservationPaymentStartBtn: 'Fizetés Indítása (POS)',
    reservationPaymentWithPassStartBtn: 'Fizetés bérlettel',
    attendReservationBtn: 'Megerősítés',
    buyOtherItemsBtn: 'Termék vásárlása',
    attendCancelBtn: 'Mégse',
  },
  successPaymentWithQRCodeModal: {
    header: 'Sikeres fizetés!',
    subHeader: 'Nyugtája megtekinthető a QR kód beolvasásával',
    confirmBtnText: 'OK',
  },
  sumUpPaymentModal: {
    header: 'Fizetés Bankkártyával',
    footer: 'A kártya elfogadó a Saspi Squash Kft A Budakalászi fallabdapálya üzemeltetője.',
  },
  cancelNotification: {
    extra: {
      text: `Kérhetsz értesítést, ha '$subjext-type-name$' pályát lemondanak ebben az időpontban.`,
      textIfAlready: `Lemondás esetén értesítést kapsz`,
      signUp: `Értesítést kérek`,
      signDown: `Mégsem`,
    },
  },
}
